var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickOutside,
          expression: "clickOutside",
        },
      ],
      class: [
        "appHeader",
        {
          collapsed: _vm.internalCollapsed,
        },
      ],
      attrs: { id: "appHeader" },
      on: { click: _vm.removeTimeout },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "logo" }, [
          _c("div", {
            staticClass: "desktopLogo",
            on: { click: _vm.onOpenWebsite },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "mobileLogo",
            on: { click: _vm.onOpenWebsite },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "iconContainer" },
          [
            _vm.showMenu
              ? _c("HeaderMenuView", {
                  staticClass: "menuView",
                  attrs: {
                    "has-about-app": !!_vm.menuAboutAppLink,
                    "has-app-review": _vm.menuHasAppReview,
                    "has-live-chat": _vm.menuHasLiveChat,
                    "has-product-categories": _vm.menuHasProductCategories,
                    "has-pricing": !!_vm.menuPricingLink,
                    "has-promotions": !!_vm.menuPromotionsLink,
                    "has-shipping": !!_vm.menuShippingLink,
                    "has-support": !!_vm.menuSupportLink,
                    "product-categories": _vm.menuProductCategories,
                  },
                  on: {
                    "open-about-app": _vm.onOpenAboutApp,
                    "open-category": _vm.onOpenCategory,
                    "open-chat": _vm.onOpenChat,
                    "open-create": _vm.onOpenCreate,
                    "open-pricing": _vm.onOpenPricing,
                    "open-promotions": _vm.onOpenPromotions,
                    "open-review-app": _vm.onOpenReviewApp,
                    "open-shipping": _vm.onOpenShipping,
                    "open-support": _vm.onOpenSupport,
                    "open-website": _vm.onOpenWebsite,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showCart
              ? _c("CartWidgetView", {
                  attrs: {
                    "has-cart-module": _vm.hasCartModule,
                    "has-edit": _vm.cartHasEdit,
                    "header-collapsed": _vm.internalCollapsed,
                    items: _vm.cartItems,
                  },
                  on: {
                    "remove-item": _vm.onRemoveCartItem,
                    "view-cart": _vm.onViewCart,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showAccountHeader
              ? _c("AccountHeaderView", {
                  staticClass: "accountHeaderView",
                  attrs: {
                    "has-login": _vm.userIsLogged,
                    "show-account": _vm.hasAccountModule,
                    "show-inbox": _vm.hasInboxModule,
                    "unread-message-count": _vm.unreadMessageCount,
                    user: _vm.userModel,
                  },
                  on: {
                    navigate: _vm.onNavigate,
                    "show-settings": _vm.onShowSettings,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-pull", on: { click: _vm.toggleVisibility } },
        [_c("i", { staticClass: "pullIcon" })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }